import { FEATURES } from './featureFlags';

export const NAVIGATION_LINKS = [
  ...(FEATURES.home ? [{ path: '/', label: 'Home' }] : []),
  ...(FEATURES.tours ? [{ path: '/tours', label: 'Tours' }] : []),
  ...(FEATURES.about ? [{ path: '/about', label: 'About' }] : []),
  ...(FEATURES.gallery ? [{ path: '/gallery', label: 'Gallery' }] : []),
  ...(FEATURES.contact ? [{ path: '/contact', label: 'Contact' }] : [])
];

export const FOOTER_LINKS = {
  quick: [
    ...(FEATURES.home ? [{ path: '/', label: 'Home' }] : []),
    ...(FEATURES.tours ? [{ path: '/tours', label: 'Tours' }] : []),
    ...(FEATURES.about ? [{ path: '/about', label: 'About' }] : []),
    ...(FEATURES.gallery ? [{ path: '/gallery', label: 'Gallery' }] : []),
    ...(FEATURES.contact ? [{ path: '/contact', label: 'Contact' }] : [])
  ],
  legal: [
    ...(FEATURES.terms ? [{ path: '/terms', label: 'Terms & Conditions' }] : []),
    ...(FEATURES.privacy ? [{ path: '/privacy', label: 'Privacy Policy' }] : []),
    ...(FEATURES.faq ? [{ path: '/faq', label: 'FAQ' }] : []),
    ...(FEATURES.gallery ? [{ path: '/gallery', label: 'Photo Gallery' }] : [])
  ]
};

export const SOCIAL_LINKS = [
  { name: 'Instagram', icon: '/images/links/Instagram_Glyph_White.png', url: 'https://instagram.com/travel_mhor', isImage: true },
  ...(process.env.REACT_APP_YOUTUBE_URL ? [{ name: 'YouTube', icon: '/images/links/YouTube_Glyph_White.png', url: process.env.REACT_APP_YOUTUBE_URL, isImage: true }] : [])
];
